import { createSlice } from "@reduxjs/toolkit";
// utils
import { PATH_DASHBOARD } from "../../routes/paths";
import axios from "../../utils/axios";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  fetchLoading: false,
  users: [],
  singleUser: null,
  singleTechnical: null,
  singleCoach: null,
  players: [],
  coaches: [],
  technical: [],
  verifiedPlayers: [],
  verifiedCoaches: [],
};

const slice = createSlice({
  name: "user",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },
    startFetchLoading(state) {
      state.fetchLoading = true;
    },

    // STOP LOADING
    stopLoading(state) {
      state.isLoading = false;
      state.fetchLoading = false;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      state.fetchLoading = false;
    },

    // TODO: successFetch User

    getUserSuccess(state, action) {
      state.isLoading = false;
      state.users = action.payload;
      state.fetchLoading = false;
    },
    getPlayerSuccess(state, action) {
      state.isLoading = false;
      state.players = action.payload;
      state.fetchLoading = false;
    },

    getVerifiedPlayerSuccess(state, action) {
      state.isLoading = false;
      state.verifiedPlayers = action.payload;
      state.fetchLoading = false;
    },

    getCoachSuccess(state, action) {
      state.isLoading = false;
      state.coaches = action.payload;
      state.fetchLoading = false;
    },

    getVerifiedCoachSuccess(state, action) {
      state.isLoading = false;
      state.verifiedCoaches = action.payload;
      state.fetchLoading = false;
    },

    getSingleCoachSuccess(state, action) {
      state.isLoading = false;
      state.singleCoach = action.payload;
      state.fetchLoading = false;
    },

    getSingleTechnicalSuccess(state, action) {
      state.isLoading = false;
      state.singleTechnical = action.payload;
      state.fetchLoading = false;
    },

    getTechnicalSuccess(state, action) {
      state.isLoading = false;
      state.technical = action.payload;
      state.fetchLoading = false;
    },

    // TODO: single User fetch success

    getSingleUserSucess(state, action) {
      state.isLoading = false;
      state.singleUser = action.payload;
      state.fetchLoading = false;
    },

    // Update User
    updateUserSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.users.data = state.users?.data?.map((usesr) => {
        if (usesr.id === action.payload.id) {
          return action.payload;
        } else {
          return usesr;
        }
      });
    },

    // Update blog
    updateCoachSuccess(state, action) {
      state.isLoading = false;
      state.coaches = state.coaches?.map((coach) => {
        if (coach.slug === action.payload.slug) {
          return action.payload;
        } else {
          return coach;
        }
      });
    },

    // delete User
    deleteUserSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.users.data = state.users.data.filter(
        (user) => user.slug !== action.payload
      );

      state.users.meta.total -= 1;
    },

    // TODO: delete player
    deletePlayerSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.players.data = state.players.data.filter(
        (player) => player.id !== action.payload
      );

      state.players.meta.total -= 1;
    },

    deleteVerifiedPlayerSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
    },

    // TODO: delete technical
    deleteTechnicalSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.technical.data = state.technical.data.filter(
        (t) => t.id !== action.payload
      );
      state.technical.meta.total -= 1;
    },

    // TODO: delete coach
    deleteCoachSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.coaches.data = state.coaches.data.filter(
        (coach) => coach.id !== action.payload
      );
      state.coaches.meta.total -= 1;
    },

    // TODO: delete coach
    deleteVerifiedCoachSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
    },
  },
});

export default slice.reducer;

// TODO: get all users
export function getUsers({ limit = 10, page = 0 }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(
        `users?limit=${limit}&page=${page + 1}`,
        {
          params: {
            filterBy: "user",
          },
        }
      );
      dispatch(
        slice.actions.getUserSuccess({
          data: response.data.data.data,
          meta: {
            total: response.data.data.total,
          },
        })
      );
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// TODO: get all players
export function getPlayers({ limit = 10, page = 0 }) {
  return async (dispatch) => {
    dispatch(slice.actions.startFetchLoading());
    try {
      const response = await axios.get(
        `player-registration?limit=${limit}&page=${page + 1}`
      );
      dispatch(
        slice.actions.getPlayerSuccess({
          data: response.data.data,
          meta: {
            total: response.data.total,
          },
        })
      );
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// TODO: get all verified players
export function getVerifiedPlayers({
  limit = 10,
  page = 0,
  season_id,
  search,
}) {
  return async (dispatch) => {
    dispatch(slice.actions.startFetchLoading());
    try {
      const response = await axios.get(`players`, {
        params: {
          season_id,
          page: page + 1,
          limit,
          ...(search && { search }),
        },
      });
      dispatch(
        slice.actions.getVerifiedPlayerSuccess({
          data: response.data.data.data,
          meta: {
            total: response.data.data.total,
          },
        })
      );
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// TODO: get all verified coaches
export function getVerifiedCoaches({ limit = 50, page = 0, search }) {
  return async (dispatch) => {
    dispatch(slice.actions.startFetchLoading());
    try {
      const response = await axios.get(`coaches`, {
        params: {
          page: page + 1,
          limit,
          ...(search && { search }),
        },
      });
      dispatch(
        slice.actions.getVerifiedCoachSuccess({
          data: response.data.data.data,
          meta: {
            total: response.data.data.total,
          },
        })
      );
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// TODO: post players
export function postPlayer({ data, enqueueSnackbar, navigate }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post("players", data);
      dispatch(
        slice.actions.getPlayerSuccess({
          data: response.data.data.data,
          meta: {
            total: response.data.data.total,
          },
        })
      );
      enqueueSnackbar("Player is added successfully");
      navigate(PATH_DASHBOARD.verified.players.list);
    } catch (error) {
      enqueueSnackbar(error.message || "Error creating player", {
        variant: "error",
      });

      dispatch(slice.actions.hasError(error));
    }
  };
}

// TODO: get single player``
export function getSinglePlayer({ id }) {
  return async (dispatch) => {
    dispatch(slice.actions.startFetchLoading());
    try {
      const response = await axios.get(`player-registration/${id}`);
      dispatch(slice.actions.getSingleUserSucess(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// TODO: get single player``
export function getSingleVerifiedPlayer({ id }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`players/${id}`);
      dispatch(slice.actions.getSingleUserSucess(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// TODO: get coaches

export function getCoach({ limit = 10, page = 0 }) {
  return async (dispatch) => {
    dispatch(slice.actions.startFetchLoading());
    try {
      const response = await axios.get(`coach-registration`, {
        params: {
          limit,
          page: page + 1,
        },
      });
      dispatch(
        slice.actions.getCoachSuccess({
          data: response.data.data,
          meta: {
            total: response.data.total,
          },
        })
      );
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// TODO: get single coach

export function getSingleCoach({ id }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`coach-registration/${id}`);
      dispatch(slice.actions.getSingleCoachSuccess(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getSingleVerifiedCoach({ id }) {
  return async (dispatch) => {
    dispatch(slice.actions.startFetchLoading());
    try {
      const response = await axios.get(`coaches/${id}`);
      dispatch(slice.actions.getSingleCoachSuccess(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getTechnical(type, limit = 2000, page = 1) {
  return async (dispatch) => {
    dispatch(slice.actions.startFetchLoading());
    try {
      const response = await axios.get(`technical-registration`);
      dispatch(
        slice.actions.getTechnicalSuccess({
          data: response.data.data,
          meta: {
            total: response.data.total,
          },
        })
      );
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// TODO: update technical
export function updateTechnical({ id, data, enqueueSnackbar }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      await axios.post(`technical-registration/${id}`, data);
      dispatch(slice.actions.stopLoading(id));
      enqueueSnackbar("Referee is updated successfully");
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });

      dispatch(slice.actions.hasError(error));
    }
  };
}

// TODO: get single coach

export function getSingleTechnical({ id }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`technical-registration/${id}`);
      dispatch(slice.actions.getSingleTechnicalSuccess(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// TODO get one user

export function postUser({ data }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post(`register`, data);
      // dispatch(slice.actions.getSingleUserSucess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function getUser(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`users/${id}`);
      dispatch(slice.actions.getSingleUserSucess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// TODO: delete one user
export function deleteUser({ id, enqueueSnackbar }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      await axios.delete(`users/${id}`);
      dispatch(slice.actions.deleteUserSuccess(id));
      enqueueSnackbar("User is deleted successfully");
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });
      dispatch(slice.actions.hasError(error));
    }
  };
}

// TODO: delete one user
export function deletePlayer({ id, enqueueSnackbar }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      await axios.delete(`player-registration/${id}`);
      dispatch(slice.actions.deletePlayerSuccess(id));
      enqueueSnackbar("Player is deleted successfully");
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });

      dispatch(slice.actions.hasError(error));
    }
  };
}

// TODO: update player
export function updatePlayer({ id, data, enqueueSnackbar }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      await axios.post(`player-registration/${id}`, data);
      dispatch(slice.actions.stopLoading(id));
      enqueueSnackbar("Player is updated successfully");
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });

      dispatch(slice.actions.hasError(error));
    }
  };
}

// TODO: delete one user
export function deleteVerifiedPlayer({
  id,
  enqueueSnackbar,
  limit,
  page,
  season_id,
}) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      await axios.delete(`players/${id}`);
      dispatch(slice.actions.deleteVerifiedPlayerSuccess(id));
      dispatch(
        getVerifiedPlayers({
          season_id,
          limit,
          page,
        })
      );
      enqueueSnackbar("Player is deleted successfully");
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });

      dispatch(slice.actions.hasError(error));
    }
  };
}

// TODO: delete one user
export function deleteTechnical({ id, enqueueSnackbar }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      await axios.delete(`technical-registration/${id}`);
      dispatch(slice.actions.deleteTechnicalSuccess(id));
      enqueueSnackbar("Technical is deleted successfully");
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });

      dispatch(slice.actions.hasError(error));
    }
  };
}

// TODO: post players
export function postCoach({ data, enqueueSnackbar, navigate }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post("coaches", data);
      dispatch(
        slice.actions.getPlayerSuccess({
          data: response.data.data.data,
          meta: {
            total: response.data.data.total,
          },
        })
      );

      enqueueSnackbar("Coach is added successfully");
      navigate(PATH_DASHBOARD.verified.coach.list);
    } catch (error) {
      enqueueSnackbar(error.message || "Error creating coach", {
        variant: "error",
      });

      dispatch(slice.actions.hasError(error));
    }
  };
}

// TODO: update coach
export function updateCoach({ id, data, enqueueSnackbar }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      await axios.post(`coach-registration/${id}`, data);
      dispatch(slice.actions.stopLoading(id));
      enqueueSnackbar("Coach is updated successfully");
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });

      dispatch(slice.actions.hasError(error));
    }
  };
}

// TODO: delete one user
export function deleteCoach({ id, enqueueSnackbar }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      await axios.delete(`coach-registration/${id}`);
      dispatch(slice.actions.deleteCoachSuccess(id));
      enqueueSnackbar("Coach is deleted successfully");
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });

      dispatch(slice.actions.hasError(error));
    }
  };
}

// TODO: update coach
export function updateVerfiedCoach({ id, data, enqueueSnackbar }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      await axios.post(`coaches/${id}`, data);
      dispatch(slice.actions.stopLoading(id));
      enqueueSnackbar("Coach is updated successfully");
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });

      dispatch(slice.actions.hasError(error));
    }
  };
}

// TODO: update coach
export function updateVerfiedPlayer({ id, data, enqueueSnackbar }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      await axios.post(`players/${id}`, data);
      dispatch(slice.actions.stopLoading(id));
      enqueueSnackbar("Player is updated successfully");
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });

      dispatch(slice.actions.hasError(error));
    }
  };
}

// TODO: delete one user
export function deleteVerfiedCoach({ id, enqueueSnackbar, limit, page }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      await axios.delete(`coaches/${id}`);
      dispatch(slice.actions.deleteVerifiedCoachSuccess(id));
      dispatch(getVerifiedCoaches({ id, enqueueSnackbar, limit, page }));
      enqueueSnackbar("Coach is deleted successfully");
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });

      dispatch(slice.actions.hasError(error));
    }
  };
}

// TODO: delete one user
export function updateUser({ id, data, enqueueSnackbar, setOpenEdit }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.put(`users/${id}`, data);
      dispatch(slice.actions.updateUserSuccess(response.data.data));
      enqueueSnackbar("User is updated successfully");
      setOpenEdit(false);
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });
      dispatch(slice.actions.hasError(error));
    }
  };
}
